export class DirectoryRequest {
    body: DirectoryRequestBody = new DirectoryRequestBody();
}

export class DirectoryRequestBody {
    ProcessName: string = "DC Get Commercial Directory List WF";
    IncomingHierarchy: IncomingHierarchy = new IncomingHierarchy();
    Language: string = "ENU";
    PageSize: string = "20";
    StartRowNum: number = 0;
    NewQuery: string = "true";
    NoDays: string = "100";
}

export class IncomingHierarchy {
    MessageId: string = "123456";
    IntObjectName: string = "DCAccountDirectoryIO";
    MessageType: string = "Integration Object";
    IntObjectFormat: string = "Siebel Hierarchical";
    ListOfDCAccountDirectoryIO: ListOfDCAccountDirectoryIO = new ListOfDCAccountDirectoryIO();
}

export class ListOfDCAccountDirectoryIO {
    ["DC Account Thin"]: DCAccountThin = new DCAccountThin();
}

export class DCAccountThin {
    "DC Name English": string = "Dubai";
    "DC Name Arabic": string = "";
}
